var storefrontApp = angular.module("storefrontApp");
storefrontApp.service('lookbookService', ['$http', function ($http) {
    return {
        getActiveLookbooks: function () {
            return $http.get('storefrontapi/learningcenter/getactivelookbooks');
        }
    }
}]);
